//Sidbar Navigation
const SIDEBAR_NAVIGATION = [
    { name: 'Пользователи', to: '/users/list', role: [1, 2] },
    { name: 'Получатели', to: '/recipients/list', role: [1, 2, 3, 6] },
    { name: 'Акции', to: '/promotions/list', role: [1, 2, 3, 6] },
]

export {
    SIDEBAR_NAVIGATION,
}